class UserMenuController {
    constructor(authService) {
        this.authService = authService;
    }

    $onInit () {
        this.user = this.authService.getProfile();
    }

    logout () {
        this.authService.logout();
    }
}

UserMenuController.$inject = ['authService'];

export default UserMenuController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/controllers/user.menu.controller.js